import { toDisplayAssetUrl } from "@/lib/assets";

type MarketplaceListingImageSource = {
  images: string[];
  fallbackImageUrl?: string | null;
};

export function getMarketplaceListingHeroImage(
  listing: MarketplaceListingImageSource
): { src: string; fit: "contain" | "cover" } | null {
  const uploadedImage = listing.images[0]?.trim();
  if (uploadedImage) {
    return {
      src: toDisplayAssetUrl(uploadedImage),
      fit: "cover",
    };
  }

  const fallbackImage = listing.fallbackImageUrl?.trim();
  if (fallbackImage) {
    return {
      src: toDisplayAssetUrl(fallbackImage),
      fit: "contain",
    };
  }

  return null;
}

export function getMarketplaceListingFallbackImageUrl(value: string | null | undefined) {
  const fallbackImage = value?.trim();
  return fallbackImage ? toDisplayAssetUrl(fallbackImage) : "";
}
